import subschoolApi from '@/api/subschool'

const subschool={
  namespaced:true,
  state:{
    data:[],
    pagination:{current:1,total:0,pageSize:10,showSizeChanger:true,showTotal:total=>`总计 ${total} 条`},
    loading:false,
    editSchool:{},
    sorter:{},
    baseinfos:[]
  },
  mutations:{
    setData:(state,data)=>{
      state.data=data
    },
    setPagination:(state,pagination)=>{
      state.pagination=pagination
    },
    setLoading:(state,loading)=>{
      state.loading=loading
    },
    edit:(state,data)=>{
      state.disabled=false
      state.editSchool=data
    },
    setSorter:(state,sorter)=>{
      state.sorter=sorter
    },
    setBaseInfos:(state,infos)=>{
      state.baseinfos=infos
    }
  },
  actions:{
    async GetAll({ commit,state },pagination){
      commit('setLoading',true)
      const page={
        skipCount:pagination.pageSize*(pagination.current-1),
        maxResultCount:pagination.pageSize,
        ...pagination
      }           
      if(state.sorter.field){
        if(state.sorter.order==='ascend'){
          page.sorting=state.sorter.field
        }else{
          page.sorting=state.sorter.field+' desc'
        }
      }
      try{
        const res=await subschoolApi.getAll(page)
        pagination.total=res.result.totalCount
        commit('setPagination',pagination)
        commit('setData',res.result.items)
      }finally {
        commit('setLoading',false)
      }
    },
    async UpdateOrAdd({ commit,dispatch,state },school){
      try{
        if(school.id){
          await subschoolApi.update(school)          
        }else{
          await subschoolApi.create(school)
        }
        commit('edit',{})
        await dispatch('GetAll',state.pagination)
      }catch(err){
        throw err
      }     
    },
    async Delete({ dispatch,state },school){
      await subschoolApi.delete(school.id)
      await dispatch('GetAll',state.pagination)
    },
    async GetBaseInfos({ commit },where){
      const res=await subschoolApi.getBaseInfos(where)
      commit('setBaseInfos',res.result.items)
    },
  }
}
export default subschool